import React from 'react';
import VendexAction, { VendexFunction } from '../models/VendexAction';
import { LOG_TYPE } from '../models/Log';
import { PageContext } from '.';

const useEventListner = (ref: React.RefObject<HTMLElement>, actions?: VendexAction[]) => {
  const { previewMode, store } = React.useContext(PageContext);

  const executeTriggerFunctions = (event: Event, eventTrigger: string) => {
    const triggerFuncs = actions?.filter(({ trigger = 'click' }) => trigger === eventTrigger) ?? [];
    for (let i = 0; i < triggerFuncs.length; i++) {
      const { type, payload } = triggerFuncs[i];

      if ((store as any)[type]) {
        store.LOG_ACTION(LOG_TYPE.USER_INTERACTION, JSON.stringify({ eventTrigger, type, payload }));
        const response = ((store as any)[type] as VendexFunction)(payload);
        if (!response) {
          event.stopPropagation();
          break;
        }
      }
    }
  };

  function createActionByTrigger(): Record<string, EventListener> {
    const record: Record<string, EventListener> = {};
    actions?.forEach(({ trigger = 'click' }) => {
      if (!record[trigger]) {
        record[trigger] = (event) => {
          executeTriggerFunctions(event, trigger);
        };
      }
    });
    return record;
  }

  React.useEffect(() => {
    if (ref.current && actions && !previewMode) {
      const element = ref.current;
      const eventsByTrigger: Record<string, EventListener> = createActionByTrigger();

      const cleanupFunctions: (() => void)[] = [];

      for (const [key, value] of Object.entries(eventsByTrigger)) {
        element.addEventListener(key, value);
        cleanupFunctions.push(() => {
          element.removeEventListener(key, value);
        });
      }

      return () => {
        cleanupFunctions.forEach((cleanupFunction) => {
          cleanupFunction();
        });
      };
    }
  }, [actions, ref]);
};

export default useEventListner;
